<template>
    <div>
        <div>
            <b-nav tabs>
                <b-nav-item router-link to="orders" v-if="canSaleView">
                    <icon name="list-alt"></icon>
                    ใบจองสินค้า
                </b-nav-item>&nbsp;
                <b-nav-item router-link to="invoices" v-if="canSaleView">
                    <icon name="file-export"></icon>
                    บิลขาย
                </b-nav-item>&nbsp;
                <b-nav-item router-link to="save-exportation" v-if="canViewAccounting">
                    <icon name="shopping-cart"></icon>
                    บันทึกส่งของ
                </b-nav-item>&nbsp;
                <b-nav-item router-link to="example-product" v-if="canViewAccounting">
                    <icon name="boxes"></icon>
                    รายละเอียดแผงตัวอย่าง
                </b-nav-item>&nbsp;
                <b-nav-item router-link to="example-gift" v-if="canViewAccounting">
                    <icon name="gift"></icon>
                    รายละเอียดประเภทของขวัญ
                </b-nav-item>&nbsp;
            </b-nav>
        </div>
        <div class="container-fluid" style="background-color: white">
            <router-view />
        </div>
    </div>
</template>

<script>
import OrderList from "../../components/Order/Order/OrderList";
import InvoiceForm from "../../components/Order/Invoice/InvoiceForm";
import {
    canViewDriver,
    canSaleView,
    canViewAccounting,
} from "../../util/Permissions";

export default {
    name: "order-layout",
    components: {
        InvoiceForm,
        OrderList,
    },
    computed:{
        canSaleView,
        canViewDriver,
        canViewAccounting,
    },

};
</script>

<style lang="scss" scoped></style>
